import { compareAsc, format } from 'date-fns';

import { utcToZonedTime } from 'date-fns-tz';

export const toNzDate = (date: Date) => {
  return utcToZonedTime(date, 'Pacific/Auckland');
};

export const todayDate = () => {
  return utcToZonedTime(new Date(), 'Pacific/Auckland');
};

export const toDateString = (date: Date) => {
  if (!date) return null;
  return format(date, 'yyyy-MM-dd');
};

export const toDate = (str: string) => {
  if (!str) return null;
  const date = new Date(str);
  return date;
};

export const differenceInDays = (dateLeft: Date, dateRight: Date) => {
  const diffTime = Math.abs(dateLeft.getTime() - dateRight.getTime());
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return diffDays * compareAsc(dateLeft, dateRight);
};

export const formatDate = (date: Date, formatter = 'dd/MM/yyyy') => {
  return format(toDate(date.toString()), formatter);
};

/**
 * Returns the next day at which the given cadence occurs, starting from the given start date and occuring after at the given target date.
 *
 * @param startDate - The start date from which to begin the search for the next cadence day.
 * @param targetDate - The target date, find the next cadence instace after this date.
 * @param cadence - The cadence, in days.
 * @returns the first date after the targetDate which is on our cadence.
 */
export function getNextCadenceDay(startDate: Date, targetDate: Date, cadence: number): Date {
  const nextCadenceDay = new Date(startDate);
  // Increment the nextCadenceDay by the given cadence until it is equal to or greater than the target date.
  while (nextCadenceDay < targetDate) {
    nextCadenceDay.setDate(nextCadenceDay.getDate() + cadence);
  }
  return nextCadenceDay;
}
